import React, { useState } from 'react'
import '../assets/css/Tryme.css'
import Particle from '../components/Particle/index'

export default function ButtonFirework() {
    const [play, setPlay] = useState(false)

    const handleClick = () => {
        setPlay(true)
        setTimeout(() => {
            setPlay(false)
        },3000)

    }   
  return (
    <button className={play === false ? 'Tryme' : 'Tryme disabled'} onClick={handleClick}>
        <Particle
        color={'red'}
        amount={130}
        maxDistanceX={200}
        maxDistanceY={200}
        maxHeight={6}
        maxWidth={6}
        dropShadow={true}
        playExploud={play}
        />
        <Particle
        color={'blue'}
        amount={130}
        maxDistanceX={200}
        maxDistanceY={200}
        maxHeight={6}
        maxWidth={6}
        dropShadow={true}
        playExploud={play}
        />
        Try Me!
    </button>
  )
}
